import { gql } from "@apollo/client";

export const CREATE_PROPERTY_ASSET = gql`
  mutation createPropertyAsset($input: CreatePropertyAssetInput!) {
    createPropertyAsset(input: $input) {
      propertyAsset {
        id
        name
        domain
        authorId
        category
        status
        geolocation {
          longitude
          latitude
        }
        identity
        details
        contactList
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_PROPERTY_ASSET = gql`
  mutation updatePropertyAsset($input: UpdatePropertyAssetInput!) {
    updatePropertyAsset(input: $input) {
      propertyAsset {
        id
        name
        domain
        authorId
        schemaType
        category
        status
        state
        geolocation {
          longitude
          latitude
        }
        identity
        details
        ref
        contactList
        createdAt
        updatedAt
      }
    }
  }
`;

export const DELETE_PROPERTY_ASSET = gql`
  mutation deletePropertyAsset($id: ID!) {
    deletePropertyAsset(id: $id) {
      id
    }
  }
`;

export const GENERATE_SATELLITE_IMAGE = gql`
  mutation generateSatelliteImage($input: GenerateSatelliteImageInput!) {
    generateSatelliteImage(input: $input) {
      imageUrl
      propertyAsset {
        id
        identity
        details
        updatedAt
      }
    }
  }
`;
